import { HttpInterceptorFn, HttpContextToken } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '@core/services/loader.service';

export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);
export const LOADER_MESSAGE = new HttpContextToken<string>(() => 'Cargando...');
const EXCLUDED_URLS: string[] = [
  '/User/Alerts',
  '/User/NotificationModals',
  '/Auth/configuration'
];
const DEBOUNCE_TIME = 100;

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  const customMessage = req.context.get(LOADER_MESSAGE);
  const shouldSkip = req.context.get(SKIP_LOADER) || EXCLUDED_URLS.some(url => req.url.includes(url));

  if (shouldSkip) {
    return next(req);
  }

  const timer = setTimeout(() => {
    loaderService.show(customMessage);
  }, DEBOUNCE_TIME);

  return next(req).pipe(
    finalize(() => {
      clearTimeout(timer);
      loaderService.hide();
    })
  );
};
